import { request } from "../../../service/api";
import { toLocalISOWithOffset } from "../../../utils/commonHelper";

export type ScheduleMode = "unset" | "every" | "times" | "weekdays" | "prn";
export type ScheduleUnit = "hours" | "days" | "weeks";
export type SchedulePeriod = "day" | "week" | "month";

/** Day-of-week index: 0 = Sunday … 6 = Saturday */
export type DayOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export interface ProductItem {
  key?: string | number;
  productFamilyDesc: string;
  materialDescription?: string;
  materialNumber?: string | number;
  materialNumberCode?: string;
  hcpcsCode?: string;
  recommended?: number;
  frequence?: string | null;
  frequenceType?: string | null;
  scheduleMode?: Exclude<ScheduleMode, "unset"> | null;
  times?: number | null;
  period?: SchedulePeriod | null;
  days?: DayOfWeek[] | null;
  prnMax?: number | null;
  prnCap?: boolean | null;
  scheduleAnchorAt?: string | null;
  nextDueAt?: string | null;
  [key: string]: unknown;
}

export interface ProductCategory {
  productCategory: ProductItem[];
}

export interface DressChangeData {
  primary?: ProductCategory;
  secondary?: ProductCategory;
}

export interface DressChangeFrequency {
  data?: DressChangeData;
}

export interface DressingChangeFrequencyParams {
  patientId: string | number;
  assessmentId: string | number;
  interventionId: string | number;
}

export interface ApiEnvelope<T> {
  status?: string;
  data?: T;
}

export interface UpdateDressingChangeFrequencyPayload extends DressingChangeFrequencyParams {
  data: DressChangeData;
}

const endpoint = ({ patientId, assessmentId, interventionId }: DressingChangeFrequencyParams): string =>
  `/patients/${patientId}/assessments/${assessmentId}/intervention/${interventionId}/dressingchangefrequency`;

export function fetchDressingChangeFrequency(
  params: DressingChangeFrequencyParams
): Promise<ApiEnvelope<DressChangeData>> {
  return request(endpoint(params), { method: "GET", skipLoader: true });
}

export function updateDressingChangeFrequency(
  payload: UpdateDressingChangeFrequencyPayload
): Promise<ApiEnvelope<DressChangeData>> {
  const { patientId, assessmentId, interventionId, data } = payload;

  return request(endpoint({ patientId, assessmentId, interventionId }), {
    method: "PATCH",
    body: JSON.stringify({ ...data, woundModifiedDate: toLocalISOWithOffset(new Date()) }),
    skipLoader: true,
  });
}
